@if (isLoading()) {
<app-spinner data-test-id="account-manage-spinner"></app-spinner>
} @else {
<app-view [justify]="ViewJustify.SPACE_BETWEEN" [spacingBottom]="Spacing.SMALL">
  <app-secondary-navigation
    [links]="links"
    data-test-id="account-manage-secondary-nav"
    [spacingBottom]="Spacing.NONE"
  ></app-secondary-navigation>
  @if (currentUrl === '/account/manage' &&
  adminUserService.hasPermission(UserPermission.READ_ACCOUNT_CREATE_ADMIN)) {
  <app-button
    type="primary"
    (handleClick)="handleAddAdminDialog()"
    data-test-id="account-manage-create-admin-button"
    [spacingBottom]="Spacing.NONE"
  >
    Create Admin
  </app-button>
  }
</app-view>
}
<router-outlet data-test-id="account-manage-router-outlet"></router-outlet>
<app-confirm-dialog
  [(isOpen)]="openAddAdminDialog"
  title="Invite new admin"
  [subTitle]="acceptedDomains"
  primaryText="Submit"
  [primaryDisabled]="inviteDisabled()"
  [headerPlacement]="ViewAlign.START"
  [headerGap]="Spacing.SMALL"
  (handlePrimaryButton)="handleInviteAdmin()"
  data-test-id="account-manage-invite-admin-dialog"
>
  <div class="account-container-wrapper">
    <div class="account-container-grid">
      <app-text-input
        [type]="InputType.TEXT"
        [size]="InputSize.LARGE"
        [(value)]="inviteAdminFirstName"
        [direction]="InputDirection.VERTICAL"
        label="First Name"
        [width]="InputWidth.FULL"
        data-test-id="account-manage-invite-first-name-input"
      ></app-text-input>
      <app-text-input
        [type]="InputType.TEXT"
        [size]="InputSize.LARGE"
        [(value)]="inviteAdminLastName"
        [direction]="InputDirection.VERTICAL"
        label="Last Name"
        [width]="InputWidth.FULL"
        data-test-id="account-manage-invite-last-name-input"
      ></app-text-input>
    </div>
    <app-text-input
      [type]="InputType.TEXT"
      [size]="InputSize.LARGE"
      [(value)]="inviteAdminEmail"
      [error]="inviteAdminEmailError"
      [errorMessage]="emailErrorMessage"
      [direction]="InputDirection.VERTICAL"
      label="Email"
      [width]="InputWidth.FULL"
      data-test-id="account-manage-invite-email-input"
    ></app-text-input>
  </div>
</app-confirm-dialog>
